export class FontFamily {
  constructor(fontFamily, fontWeight) {
    this.fontFamily = fontFamily;
    this.fontWeight = fontWeight;
  }
  value() {
    return {
      fontFamily: this.fontFamily,
      fontWeight: this.fontWeight
    };
  }
}
//# sourceMappingURL=FontFamily.js.map